import {Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren, ChangeDetectionStrategy} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {ConfirmationModalComponent} from "../../../components/confirmation-modal/confirmation-modal.component";
import {FormControl, FormGroup} from "@angular/forms";
import {EquityInstallmentService, UpdateInstallmentObservableMode} from "../../equity-installment.service";
import {DatePipe} from "@angular/common";
import ProjectEquityInstallmentFunding from "../../../interfaces/project-installment-funding";
import {forkJoin, Observable, Subscription} from "rxjs";
import ProjectInstallmentStatus from "../../../interfaces/project-installment-status";
import ProjectInstallmentFundingStatus from "../../../interfaces/project-installment-funding-status";
import Permission from "../../../interfaces/permission";
import {
  EquityInstallmentSharepointService
} from "../equity-installment-documents-panel/equity-installment-sharepoint.service";
import {DataFormatService} from "../../../services/data-format.service";
import {EquityInstallmentFundingComponent} from "../equity-installment-funding/equity-installment-funding.component";

@Component({
    selector: 'equity-installment-installment-entry',
    templateUrl: './equity-installment-installment-entry.component.html',
    styleUrls: ['./equity-installment-installment-entry.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EquityInstallmentInstallmentEntryComponent implements OnInit{
  @Input() installment:any;
  @Input() expanded:boolean = false;
  @Output() expandPanel: EventEmitter<string> = new EventEmitter<string>()
  @Output() closePanel: EventEmitter<string> = new EventEmitter<string>()
  @ViewChildren(EquityInstallmentFundingComponent) fundingComponents: QueryList<EquityInstallmentFundingComponent>
  public installmentStatuses: ProjectInstallmentStatus[] = []
  public installmentForm: FormGroup = new FormGroup<any>({
    installment_number: new FormControl(),
    installment_amount: new FormControl(),
    total_funded: new FormControl(),
    total_adjusters: new FormControl(),
    remaining: new FormControl(),
    status: new FormControl(),
    original_commitment_date: new FormControl(),
    notes: new FormControl()
  })

  public fundings:ProjectEquityInstallmentFunding[] = []
  public fundingStatuses: ProjectInstallmentFundingStatus[] = []
  public fundingsSub: Subscription
  public statusSub:Subscription
  public userSub: Subscription
  public expandedIds = new Set<string>()
  public fundingStatusSub:Subscription
  public permissionsSub:Subscription
  public permissions:any;
  public readOnly:boolean = false;
  public user:any;
  public notesExpanded: boolean = false;

  constructor(public dialog: MatDialog, private equityService: EquityInstallmentService, private _datePipe: DatePipe, private dataFormat: DataFormatService, private sharepointService: EquityInstallmentSharepointService) {
  }


  ngOnInit() {
    //TODO: This is Temporary, replace later
    //this.checkReadOnlyStatus()
    this._setInstallmentForm()
    this.fundingsSub = this.equityService.installmentFundings$.subscribe((result) => {
      this.fundings = result[this.installment.id]
      this.fundings = [...this.fundings].sort((a:ProjectEquityInstallmentFunding, b:ProjectEquityInstallmentFunding) => {
        const normalizeStatus = (val?: string) => (val ?? "").toLowerCase()

        const aClosed = normalizeStatus(a.projectInstallmentFundingStatus?.name) === 'fully approved'
        const bClosed = normalizeStatus(b.projectInstallmentFundingStatus?.name) === 'fully approved'

        if(aClosed !== bClosed){
          return aClosed ? 1 : -1
        }
        return a.funding_number - b.funding_number
      })
    })

    this.statusSub = this.equityService.projectInstallmentStatuses$.subscribe((result) => {
      this.installmentStatuses = result;
    })

    this.userSub = this.equityService.user$.subscribe((result) => this.user = result)

    this.permissionsSub = this.equityService.permissions$.subscribe((result) => this.permissions = result)

    this.fundingStatusSub = this.equityService.projectInstallmentFundingStatuses$.subscribe((result) => {
      this.fundingStatuses = result;
    })

  }


  private _setInstallmentForm(){
    this.installmentForm.controls['installment_number'].setValue(this.installment.installment_number)
    this.installmentForm.controls['installment_amount'].setValue(this.installment.installment_amount)
    this.installmentForm.controls['status'].setValue(this.installment.projectInstallmentStatus!== null ? this.installment.projectInstallmentStatus.id : null)
    this.installmentForm.controls['total_funded'].setValue(this.installment.total_funded_amount)
    this.installmentForm.controls['total_adjusters'].setValue(this.installment.total_adjuster_amount)
    this.installmentForm.controls['remaining'].setValue(this.installment.total_remaining_amount)
    this.installmentForm.controls['original_commitment_date'].setValue(this.installment.original_commitment_date)
    this.installmentForm.controls['notes'].setValue(this.installment.notes)
  }

  public openDeleteConfirmationModal(){
    let dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '600px',
      height: '200px',
      data: {
        modalTitle: 'Delete Installment ' + this.installment.installment_number,
        actionMessage: 'Are you sure you want to delete this installment?',
      }
    })

    dialogRef.afterClosed().subscribe((data) => {
      if(data.clicked === 'Ok'){
        this.equityService.deleteInstallment(this.installment.id).subscribe((response:any) => {
          this.equityService.openSnackBar('Installment removed.', 'save-success')
          let rs = response as any;
          let resultData = rs.data.deleteProjectInstallment
          this.equityService.updateInstallments(UpdateInstallmentObservableMode.REMOVE,resultData)
        })
      }
    })
  }

  public openAddFundingConfirmation(){
    let dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '600px',
      height: '200px',
      data: {
        modalTitle: 'Add Funding?',
        actionMessage: 'Are you sure you want to add another funding to this installment?'
      }
    })

    dialogRef.afterClosed().subscribe((data:any) => {
      if(data.clicked == 'Ok'){
        this.addFunding();
      }
    })
  }

  public addFunding(){
    let status = this.fundingStatuses.find(
      (status: ProjectInstallmentFundingStatus) => status.name.toUpperCase() == 'DUE'
    )
    let fundingNumber = this.fundings.length ? Math.max(...this.fundings.map(f => f.funding_number)) + 1: 1
    let defaultFunding = {
      project_installment_id: this.installment.id,
      project_installment_funding_status_id: null,
      funding_number: fundingNumber,
      funding_status_date: null
    }
    this.equityService.createInstallmentFunding(defaultFunding).subscribe((result) => {
      this.equityService.openSnackBar('Funding added.', 'save-success')
      let rs = result as any;
      let resultFunding: ProjectEquityInstallmentFunding = rs.data.createProjectInstallmentFunding;
      this.equityService.updateInstallmentFundings(UpdateInstallmentObservableMode.ADD, resultFunding)
    })
  }

  public updateInstallment(){
    let dataVar = {
      id: this.installment.id,
      installment_number: this.installmentForm.value.installment_number,
      installment_amount: this.dataFormat.commaCurrencyToInt(this.installmentForm.value.installment_amount),
      project_installment_status_id: this.installmentForm.value.status,
      original_commitment_date: this._datePipe.transform(this.installmentForm.value.original_commitment_date, 'yyyy-MM-dd'),
      notes: this.installmentForm.value.notes
    }
    this.equityService.updateInstallment(dataVar).subscribe((response:any) => {
      this.equityService.openSnackBar('Installment updated.', 'save-success')
      let rs = response as any;
      let resultData = rs.data.updateProjectInstallment
      this.equityService.updateInstallments(UpdateInstallmentObservableMode.UPDATE,resultData)
    })
  }

  public save(){
    const ops: Observable<any>[] = [];

    if(!this.readOnly && this.permissions?.installmentPermissions?._edit && this.installmentForm.dirty){
      ops.push(
        this.equityService.updateInstallment({
          id: this.installment.id,
          installment_number: this.installmentForm.value.installment_number,
          installment_amount: this.dataFormat.commaCurrencyToInt(this.installmentForm.value.installment_amount),
          project_installment_status_id: this.installmentForm.value.status,
          original_commitment_date: this._datePipe.transform(this.installmentForm.value.original_commitment_date, 'yyyy-MM-dd'),
          notes: this.installmentForm.value.notes,
        }),
      )
    }
    this.fundingComponents.forEach(fc => ops.push(fc.save()));
    return forkJoin(ops);
  }

  public deleteFunding(event_id:string){
    this.equityService.deleteInstallmentFunding(event_id).subscribe((response:any) => {
      this.equityService.openSnackBar('Funding removed.', 'save-success')
      this.equityService.refresh()
    })
  }

  public refreshInstallment(event:any){
    this.equityService.refetchInstallment(this.installment.id).subscribe((response:any) => {
      this.installment = response.data.project_installment
      this.equityService.updateInstallments(UpdateInstallmentObservableMode.UPDATE, this.installment)
    })
  }

  private checkReadOnlyStatus(){
    if(this.installment.projectInstallmentStatus!==null && this.installment.projectInstallmentStatus.name.toUpperCase()=='PAID'){
      this.readOnly = true;
    }
  }

  public checkPermissions(permission: Permission, key:string){
    return this.equityService.checkPermissions(permission, '_edit', key)
  }

  public togglePanel(){
    if(this.expanded){
      this.closePanel.emit(this.installment.id)
    } else {
      this.expandPanel.emit(this.installment.id)
      this.sharepointService.openFolderFromInstallment(this.installment.installment_number)
    }
  }

  ngOnDestroy(){
    this.fundingsSub.unsubscribe()
    this.statusSub.unsubscribe()
    this.userSub.unsubscribe()
    this.permissionsSub.unsubscribe()
  }

}
